import React from 'react';
import { ExternalLink } from 'lucide-react';
import { CaseStudy } from '../types';

interface CaseStudyCardProps {
  caseStudy: CaseStudy;
}

export const CaseStudyCard: React.FC<CaseStudyCardProps> = ({ caseStudy }) => {
  return (
    <article className="case-study-card">
      <div>
        <div className="case-study-meta">
          <span className="case-study-category">{caseStudy.category}</span>
        </div>

        <h3 className="case-study-title">{caseStudy.title}</h3>
        <p className="case-study-subtitle">{caseStudy.subtitle}</p>
        <p className="case-study-summary">{caseStudy.summary}</p>

        <ul className="case-study-impact-list">
          {caseStudy.impact.map((point, index) => (
            <li key={index} className="case-study-impact-item">{point}</li>
          ))}
        </ul>
      </div>

      <div>
        <div className="tag-list" style={{ marginBottom: '1.25rem' }}>
          {caseStudy.tech_stack.map((tech) => (
            <span key={tech} className="tag">{tech}</span>
          ))}
        </div>

        {caseStudy.external_links && (
          <div className="case-study-footer">
            {Object.entries(caseStudy.external_links).map(([label, url]) => (
              <a
                key={label}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-secondary"
                style={{ padding: '0.4rem 1rem', fontSize: '0.85rem' }}
              >
                <span>{label}</span>
                <ExternalLink size={14} />
              </a>
            ))}
          </div>
        )}
      </div>
    </article>
  );
};
